import Button from "@/Components/Common/Buttons/Buttons";
import React, { useEffect, useState } from "react";
import { useCheckZipcodeMutation, useClinicAddressMutation, usePhysicianAddressMutation } from "../../../Redux/apis/auth";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { userData } from "@/Redux/apis/userData";
import { useGetUsaStatesQuery } from "../../../Redux/apis/content";
import { toast } from "react-toastify";
const EditLocation = ({
  isOpen,
  onClose,
  user
}) => {
  if (!isOpen) return null;
  const dispatch = useDispatch();
  const token = useSelector(state => state?.token?.token);
  const [loading, setLoading] = useState(false);
  const [usaStatesData, setUsaStatesData] = useState();
  const {
    register,
    handleSubmit,
    formState: {
      errors
    },
    watch,
    setValue
  } = useForm({
    defaultValues: {
      addressLine1: user?.addressLine1 || "",
      addressLine2: user?.addressLine2 || "",
      zipCode: user?.zipCode || "",
      state: user?.state || ""
    }
  });
  const [zipcodeError, setZipcodeError] = useState(false);
  const zipCodeValue = watch("zipCode");
  const zipCodePattern = /^\b\d{5}\b(?:[- ]{1}\d{4})?$/;
  const [checkZipcode] = useCheckZipcodeMutation();
  const [physicianAddress, physicianAddressResponse] = usePhysicianAddressMutation();
  const [clinicAddress, clinicAddressResponse] = useClinicAddressMutation();
  const getUsaStates = useGetUsaStatesQuery({
    refetchOnMountOrArgChange: true
  });
  useEffect(() => {
    const {
      data,
      isLoading,
      isError
    } = getUsaStates;
    if (!isLoading && data) {
      // Sort alphabetically so the dropdown matches the signup form
      // (ProfileSetting.jsx). Backend returns states in Mongo
      // insertion order, which is unpredictable.
      const sorted = [...(data.data || [])].sort((a, b) => String(a?.name || "").localeCompare(String(b?.name || "")));
      setUsaStatesData(sorted);
    } else if (isError) {
      setUsaStatesData([]);
    }
  }, [getUsaStates]);
  const handleCheckZipcode = async zipCode => {
    try {
      const response = await checkZipcode({
        zipCode
      }).unwrap();
      if (response.status) {
        setZipcodeError(false);
        const fullAddress = response?.addressDetails?.address?.address;
        const addressParts = fullAddress.split(', ');
        const addressLine1 = addressParts.slice(0, 3).join(', ');
        const addressLine2 = addressParts.slice(3).join(', ');

        // Set the values for addressLine1 and addressLine2
        setValue("addressLine1", addressLine1);
        setValue("addressLine2", addressLine2);
        setValue("state", response?.addressDetails?.address?.state);
      }
    } catch (e) {
      console.error("Error in zipcode checking:", e);
      setZipcodeError(true);
      setValue("addressLine1", '');
      setValue("addressLine2", '');
      setValue("state", '');
    }
  };
  useEffect(() => {
    if (zipCodeValue && !errors.zipCode && zipCodePattern.test(zipCodeValue)) {
      // If zip code is valid and matches the pattern, call the API
      handleCheckZipcode(zipCodeValue);
    }
  }, [zipCodeValue, errors.zipCode]);
  const handleAddressForm = async data_0 => {
    if (zipcodeError) return;
    setLoading(true);
    try {
      if (!data_0 && !data_0?.zipcode) {
        toast.error("Please enter required fields!");
        setLoading(false);
        return;
      }
      try {
        const dataToSend = {
          userId: user?._id,
          ...data_0
        };
        if (user?.type === 'physician') {
          await physicianAddress(dataToSend);
        } else {
          await clinicAddress(dataToSend);
        }
      } catch (error_0) {
        console.error("Error sending form data:", error_0);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setLoading(false); // Set loading to false in case of an error
    }
  };
  useEffect(() => {
    const handleAddressResponse = async () => {
      if (physicianAddressResponse?.isLoading) {
        setLoading(true);
      } else if (!physicianAddressResponse?.isLoading && physicianAddressResponse?.isSuccess) {
        const data_1 = {
          token: token
        };
        toast.success(`Location update successfully`);
        setLoading(false);
        onClose();
        await dispatch(userData(data_1)); // Wait for userData to be updated
      } else if (physicianAddressResponse?.isError && physicianAddressResponse?.status === "rejected" && physicianAddressResponse?.error?.status === 400) {
        toast.error(physicianAddressResponse?.error?.data?.message);
        setLoading(false);
      }
    };
    handleAddressResponse();
  }, [physicianAddressResponse]);
  useEffect(() => {
    const handleClinicAddressResponse = async () => {
      if (clinicAddressResponse?.isLoading) {
        setLoading(true);
      } else if (!clinicAddressResponse?.isLoading && clinicAddressResponse?.isSuccess) {
        const data_2 = {
          token: token
        };
        toast.success(`Location update successfully`);
        setLoading(false);
        onClose();
        await dispatch(userData(data_2)); // Wait for userData to be updated
      } else if (clinicAddressResponse?.isError && clinicAddressResponse?.status === "rejected" && clinicAddressResponse?.error?.status === 400) {
        toast.error(clinicAddressResponse?.error?.data?.message);
        setLoading(false);
      }
    };
    handleClinicAddressResponse();
  }, [clinicAddressResponse]);
  return <>
      <div className="fixed inset-0 popup-bg flex justify-center z-50 items-end sm:items-center">
        <form onSubmit={handleSubmit(handleAddressForm)} className="w-full sm:w-auto h-full sm:h-auto flex flex-col">

        <div className="w-full sm:w-[493px] bg-white p-4 sm:p-5 rounded-none sm:rounded-xl h-full sm:h-auto flex flex-col">
          {/* Header */}
          <div className="flex justify-between items-center pb-2 border-b border-[#E1E1E1] flex-shrink-0">
            <div className="text-sm sm:text-[16px] text-[#2E0B34] font-poppins font-semibold">
              Edit Address
            </div>
            <div onClick={onClose} className="w-6 h-6 cursor-pointer flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.00049 17.5864C4.60999 17.977 4.61005 18.6101 5.00061 19.0006C5.39117 19.3911 6.02433 19.3911 6.41482 19.0005L12.0001 13.4143L17.5858 19C17.9763 19.3905 18.6095 19.3905 19 19C19.3905 18.6095 19.3905 17.9763 19 17.5858L13.4142 12L18.9996 6.41359C19.39 6.02303 19.39 5.38987 18.9994 4.99938C18.6089 4.60888 17.9757 4.60894 17.5852 4.9995L11.9999 10.5858L6.41414 4.99998C6.02362 4.60946 5.39045 4.60946 4.99993 4.99998C4.6094 5.39051 4.6094 6.02367 4.99993 6.4142L10.5859 12.0001L5.00049 17.5864Z" fill="#8E8E8E" />
              </svg>
            </div>
          </div>
          <div className="text-xs sm:text-[14px] font-light pt-2 text-[#8E8E8E] font-poppins flex-shrink-0">
            Update your permanent address details below (Only zipcode is required.)
          </div>

          {/* Scrollable Content */}
          <div className="w-full flex-1 overflow-y-auto sm:overflow-visible pb-4 sm:pb-0">
            <div className="mt-3 sm:mt-4">
              <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#8E8E8E]">
                Zip Code{" "}
              </div>
              <div className="border rounded-lg mt-1.5 sm:mt-2">
                <input {...register("zipCode", {
                  required: "Zip Code is required",
                  pattern: {
                    value: /^\b\d{5}\b(?:[- ]{1}\d{4})?$/,
                    message: "Invalid ZIP Code format"
                  }
                })} type="text" placeholder="" className="border-none rounded-lg py-2 px-2 sm:px-3 outline-none w-full text-sm sm:text-base" />
              </div>
              {errors.zipCode && <span className="text-red-500 text-xs sm:text-sm">
                    {errors.zipCode.message}
                  </span>}
              {!errors.zipCode && zipcodeError && <span className="text-red-500 text-xs sm:text-sm">
                    Invalid zipcode*
                  </span>}
            </div>{" "}
            <div className="mt-3 sm:mt-4">
              <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#8E8E8E]">
                Address Line 1
              </div>
              <div className="border rounded-lg mt-1.5 sm:mt-2">
                <input {...register("addressLine1")} type="text" placeholder="" className="border-none rounded-lg py-2 px-2 sm:px-3 outline-none w-full text-sm sm:text-base" />
              </div>
            </div>
            <div className="mt-3 sm:mt-4">
              <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#8E8E8E]">
                Address Line 2
              </div>
              <div className="border rounded-lg mt-1.5 sm:mt-2">
                <input {...register("addressLine2")} type="text" placeholder="" className="border-none rounded-lg py-2 px-2 sm:px-3 outline-none w-full text-sm sm:text-base" />
              </div>
            </div>{" "}
            <div className="mt-3 sm:mt-4">
              <div className="text-xs sm:text-[14px] font-medium font-poppins text-[#8E8E8E]">
                State{" "}
              </div>
              <div className="select_box w-full px-3 sm:px-4 pt-2 sm:pt-2.5 pb-2 sm:pb-[9px] rounded-[10px] border border-blue-600 bg-neutral-100 justify-between inline-flex self-stretch mt-1.5 sm:mt-2">
                <select {...register("state")} className="border-none w-full outline-none bg-neutral-100 text-sm sm:text-base" value={register.state}>
                  <option disabled selected hidden className="cursor-pointer" value="">
                    Select Degree
                  </option>
                  {usaStatesData ? usaStatesData?.map((ele, index) => <option key={index} className="cursor-pointer" value={ele?.name}>
                              {ele?.name}
                            </option>) : ""}
                </select>
              </div>
            </div>
          </div>

          {/* Fixed Bottom Buttons */}
          <div className="mt-auto sm:mt-4 pt-3 sm:pt-0 border-t sm:border-t-0 border-gray-100 flex justify-between gap-3 sm:gap-7 items-center flex-shrink-0 bg-white">
            <div onClick={onClose} className="w-[50%]">
              <Button textColor={"#354EF0"} fontSize={"14px"} fontWeight={500} border={"1px solid #354EF0"} borderRadius={"10px"} padding={'10px 0px'}>
                Cancel
              </Button>
            </div>
            <div className="w-[50%]">
              <Button disabled={zipcodeError} type='submit' textColor={"white"} fontSize={"14px"} fontWeight={500} borderRadius={"10px"} padding={'10px 0px'} backgroundColor={zipcodeError ? '#7b88ec' : '#354EF0'}>
                {loading ? "Processing..." : "Update Address"}
              </Button>
            </div>
          </div>
        </div>
        </form>
      </div>
    </>;
};
export default EditLocation;